// Centralizes category and text filtering rules used by compact and expanded Store Action views.
import { CompactStoreActionCategory, StoreAction } from './storeActionDomain';
import { resolveStoreActionCategory } from './storeActionTypeCatalog';

export const COMPACT_STORE_ACTION_CATEGORY_ORDER: ReadonlyArray<CompactStoreActionCategory> =
  ['ALL', 'AGR', 'INV', 'CUS', 'FACTPAY', 'OTHER'];
export type CompactStoreActionCategoryCounts = Readonly<
  Record<CompactStoreActionCategory, number>
>;

export const formatStoreActionCount = (count: number): string =>
  count >= 999 ? '999+' : String(count);

export const getCompactCategoryCounts = (
  countsByCategory: Readonly<Record<string, number>>,
  totalCount: number
): CompactStoreActionCategoryCounts => {
  const counts: Record<CompactStoreActionCategory, number> = {
    ALL: totalCount,
    AGR: 0,
    INV: 0,
    CUS: 0,
    FACTPAY: 0,
    OTHER: 0,
  };
  Object.keys(countsByCategory).forEach((category) => {
    const compactCategory =
      resolveStoreActionCategory(category).compactCategory;
    counts[compactCategory] += countsByCategory[category];
  });
  return counts;
};
export const filterStoreActionItemsByCompactCategory = <
  Item extends Pick<StoreAction, 'storeActionCategory'>
>(
  items: ReadonlyArray<Item>,
  category: CompactStoreActionCategory
): ReadonlyArray<Item> =>
  category === 'ALL'
    ? items
    : items.filter(
        (item) =>
          resolveStoreActionCategory(item.storeActionCategory)
            .compactCategory === category
      );

export const filterExpandedStoreActionItems = <
  Item extends Pick<StoreAction, 'description' | 'storeActionCategory'>
>(
  items: ReadonlyArray<Item>,
  category: CompactStoreActionCategory,
  searchQuery: string
): ReadonlyArray<Item> => {
  const normalizedQuery = searchQuery.trim().toLocaleLowerCase();
  return items.filter(
    (item) =>
      (category === 'ALL' ||
        resolveStoreActionCategory(item.storeActionCategory).compactCategory ===
          category) &&
      (normalizedQuery.length === 0 ||
        item.description.toLocaleLowerCase().includes(normalizedQuery))
  );
};
